import React, { useContext, useState } from 'react';
import { CgRadioCheck, CgRadioChecked } from 'react-icons/cg';
import { FaMapMarkerAlt } from 'react-icons/fa';
import { Link } from 'react-router-dom';
import toast from '../../utils/helpers';
import AddressCard from '../../Components/AddressCard/AddressCard';
import Button from '../../Components/Button/Button';
import { Context } from '../../Context/Context';
import { CLEAR_CART } from '../../Context/Reducers/cartReducer';
import styles from './PaymentChoice.module.scss';
import { CartContext } from '../../Context/CartContext/CartContext';

const PaymentChoice = () => {
  const {
    state: {
      defaultAddress: {
        id, firstName, lastName, address1, state, pin, phone,
      },
    },
  } = useContext(Context);
  const { dispatch } = useContext(CartContext);
  const [paymentMethod, setPaymentMethod] = useState('Razor Pay');

  const handleRadio = (value: string) => {
    setPaymentMethod(value);
  };

  const handlePlaceOrder = () => {
    dispatch({
      type: CLEAR_CART,
    });
    toast('Order placed');
  };

  return (
    <div className={styles.container}>
      <div className={styles.centeredContainer}>
        <h1>Delivering to</h1>
        {id !== 0
          && (
            <AddressCard
              id={id}
              fullName={`${firstName} ${lastName}`}
              address={`${address1}, ${state.slice(0, 2).toUpperCase()} ${pin}, India`}
              phoneNumber={`(+91) ${phone}`}
              checkbox={false}
              hideCheckbox
            />
          )}
        <Link to="/address" className={styles.linkStyle}>
          <div className={styles.addressSelector}>
            <FaMapMarkerAlt />
            <div>
              {id === 0 ? 'Select' : 'Change'}
              {' '}
              Your Address
            </div>
          </div>
        </Link>
        <div className={styles.radioContainer}>
          <h1>Method of payment</h1>
          <div
            className={styles.radio}
            onClick={() => { handleRadio('Razor Pay'); }}
            onKeyDown={() => { handleRadio('Razor Pay'); }}
            role="button"
            tabIndex={0}
          >
            {paymentMethod === 'Razor Pay' ? <CgRadioChecked /> : <CgRadioCheck />}
            <div className={styles.label}>
              Razor Pay
            </div>
          </div>
          <div
            className={styles.radio}
            onClick={() => { handleRadio('Visa / Mastercard / UPI'); }}
            onKeyDown={() => { handleRadio('Visa / Mastercard / UPI'); }}
            role="button"
            tabIndex={0}
          >
            {paymentMethod === 'Visa / Mastercard / UPI' ? <CgRadioChecked /> : <CgRadioCheck />}
            <div className={styles.label}>
              Visa / Mastercard / UPI
            </div>
          </div>
          <div
            className={styles.radio}
            onClick={() => { handleRadio('Pay Pal'); }}
            onKeyDown={() => { handleRadio('Pay Pal'); }}
            role="button"
            tabIndex={0}
          >
            {paymentMethod === 'Pay Pal' ? <CgRadioChecked /> : <CgRadioCheck />}
            <div className={styles.label}>
              Pay Pal
            </div>
          </div>
        </div>
      </div>
      <Link
        to="/thank-you"
        className={styles.linkStyle}
        onClick={handlePlaceOrder}
      >
        <Button>
          Proceed to payment
        </Button>
      </Link>
    </div>
  );
};

export default PaymentChoice;
